var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHelp = function SvgHelp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.68469 9.6847C9.92172 8.66314 10.8522 7.95484 11.8999 7.99832C13.0726 7.93337 14.0779 8.82697 14.1509 9.99916C14.1509 11.5037 12 12 12 13.0004",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1252 15.7517C12.1251 15.8207 12.0691 15.8766 12.0001 15.8766C11.9311 15.8766 11.8751 15.8206 11.8751 15.7516C11.8751 15.6826 11.931 15.6266 12 15.6265C12.0332 15.6265 12.0651 15.6396 12.0886 15.6631C12.1121 15.6866 12.1252 15.7185 12.1252 15.7517",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6284 17.1604C1.9453 13.3307 2.63481 8.08535 6.21651 5.07915C9.79821 2.07295 15.0836 2.30336 18.3901 5.60986C21.6966 8.91636 21.927 14.2018 18.9208 17.7835C15.9146 21.3652 10.6693 22.0547 6.83959 19.3716L3.99667 20.0033L4.6284 17.1604Z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHelp);
export default ForwardRef;